<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Subscription Map Tiles</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmUpdateSubscriptionMapTiles">
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input"
                type="number"
                ref="subscriptionMapTiles"
                placeholder="New subscription map tiles"
                v-model="subscriptionMapTiles"
                :disabled="isUpdatingSubscriptionMapTiles"
              />
              <span class="icon is-small is-left">
                <i class="icon-mail"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="subscriptionMapTilesError">{{ subscriptionMapTilesError }}</p>
          </div>

          <input type="submit" style="display: none"/>
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="updateSubscriptionMapTilesError">
          {{updateSubscriptionMapTilesError}}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button
              class="button"
              @click="cancelUpdateSubscriptionMapTiles"
              :disabled="isUpdatingSubscriptionMapTiles"
            >Cancel</button>
            <button
              class="button is-primary"
              @click="confirmUpdateSubscriptionMapTiles"
              :class="{'is-loading': isUpdatingSubscriptionMapTiles}"
              :disabled="isUpdatingSubscriptionMapTiles"
            >Update</button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  UPDATE_SUBSCRIPTION_MAP_TILES
} from './userStore'

export default {
  name: 'UserUpdateSubscriptionMapTilesModal',

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      subscriptionMapTiles: null,
      isUpdatingSubscriptionMapTiles: false,
      subscriptionMapTilesError: null,
      updateSubscriptionMapTilesError: null
    };
  },

  mounted() {
    this.$refs.subscriptionMapTiles.focus()
  },

  methods: {
    cancelUpdateSubscriptionMapTiles() {
      this.$emit('cancelled')
    },

    async confirmUpdateSubscriptionMapTiles() {
      if (this.subscriptionMapTiles === null || this.subscriptionMapTiles === '') {
        this.subscriptionMapTilesError = 'Subscription map tiles can not be empty'
        return
      }

      this.updateSubscriptionMapTilesError = null
      this.isUpdatingSubscriptionMapTiles = true

      try {
        const updateSubscriptionMapTilesAction = `${this.userStorePath}/${UPDATE_SUBSCRIPTION_MAP_TILES}`
        await this.$store.dispatch(updateSubscriptionMapTilesAction, { newSubscriptionMapTiles: this.subscriptionMapTiles })

        this.$emit('succeeded')
      } catch (error) {
        this.updateSubscriptionMapTilesError = error || 'Something went wrong.'
      } finally {
        this.isUpdatingSubscriptionMapTiles = false
      }
    }
  },

  watch: {
    subscriptionMapTiles() {
      this.subscriptionMapTilesError = null;
    },
  }
};
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
